import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import { useNavigate, useParams } from 'react-router-dom'
import LandingPageMobileTemplateForm from './LandingPageMobileTemplateForm'

const mapStateToProps = () => ({})

const LandingPageMobileTemplateCreate = ({ dispatch }) => {
  const { t } = useTranslation()

  const navigate = useNavigate()
  const routeParams = useParams()
  const { type } = routeParams

  const onSubmit = payload => {
    dispatch({
      type: 'landingPage/createLandingPage',
      payload,
      successCallback: () => {
        dispatch({
          type: 'app/notify',
          payload: { message: t('messages.landing_template_created'), severity: 'success' },
        })
        navigate(`/phish_template_landing/${type}`, { replace: true })
      },
      errorCallback: message => {
        dispatch({
          type: 'app/notify',
          payload: { message, severity: 'error' },
        })
      },
    })
  }

  return <LandingPageMobileTemplateForm onSubmit={onSubmit} type={type} />
}

export default connect(mapStateToProps)(LandingPageMobileTemplateCreate)
